var map = {
	"./montserrat/montserrat-bold.ttf": 89889,
	"./montserrat/montserrat-regular.ttf": 11992,
	"./openSans/opensans-bold.ttf": 22145,
	"./openSans/opensans-extrabold.ttf": 81803,
	"./openSans/opensans-italic.ttf": 35924,
	"./openSans/opensans-light.ttf": 85856,
	"./openSans/opensans-regular.ttf": 88696,
	"./openSans/opensans-semibold.ttf": 23659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39452;